export const isRestrictionField = field => field?.id === 'isWarranty';

export const findWarrantyField = data => {
	if (!data || typeof data !== 'object') return undefined;
	return Object.values(data)
		.flatMap(section => (Array.isArray(section?.fields) ? section.fields : []))
		.find(isRestrictionField);
};
